/** en.js文件**/
module.exports = {
    // 首页
    home: {
        title: 'Marketing Management System',
        technical: 'Technical support: liushulong1',
        suggestion: 'I have a suggestion',
        userSwitch: 'user switch',
        logOut: 'log out',
        qe: 'Quick Entry',
        ea: 'Event Application',
        ed: 'Event Detail',
        EL: 'Event List',
        aff: 'Pre-application',
        regionalReporting: 'Regional Reporting Application',
        industryReporting: 'Industry Reporting Application',
        industryHeadReporting: 'Industry Head Reporting Application',
        industryTemplateReporting: 'Industry Template Reporting Application',
        RL: 'Report List',
        RD: 'Report Details',
        iL: 'Industry Reporting List',
        iD: 'Industry Reporting Details',
        rrL: 'Regional Reporting List',
        rrD: 'Regional Reporting Details',
        ca: 'Channel application',
        annualMarketingPlan: 'Annual Marketing Plan',
        qa: 'Quick Application',
        ai: 'Activity Inquiry',
        db: 'Draft Box',
        vr: 'Visit Reservation',
        hwd: 'Help Center',
        hd: 'Historical documents',
        pa: 'Pending Approval',
        Approved: 'Approval',
        r: 'Rejected',
        pf: 'Pending feedback',
        pv: 'Pending Reimbursement',
        vip: 'Reimbursement in progress',
        empty: 'It\'s empty',
        cc: 'Clue Center',
        ntbp: 'Number to be processed',
        nof: 'Number of follow-ups',
        nos: 'Number of Suspended',
        nop: 'Number of processed',
        coe: 'Calendar of events',
        ra: 'Regional Event',
        ha: 'Headquarter Event',
        Mon: 'Mon',
        Tue: 'Tue',
        Wed: 'Wed',
        Thu: 'Thu',
        Fri: 'Fri',
        Sat: 'Sat',
        Sun: 'Sun',
        AE: 'Additional Expense',
        RAE: 'Report Additional Expense',
        DoB: 'Details of Budget',
        BP: 'Budget Performance',
        BPP: 'Budget Performance Permission Management',
        single: 'single',
        LocP: 'Leads',
        DoC: 'Details of Clues',
        Pending: 'Pending',
        Fuby: 'Follow up by yourself',
        Processed: 'Processed',
        PutUp: 'Put Up',
        qddhbm: '2026-APAC Conference Registration'
    },
    // 新建申请
    newApp: {
        // 基本信息
        BasicInfo: {
            bi: 'Basic information',
            target: 'Annual Planning Target',
            an: 'Event Number',
            fs: 'Financial system',
            toc: 'Types of Currency',
            Applicant: 'Applicant',
            ci: 'Contact information',
            ct: 'Contract type',
            cn: 'Company Name',
            at: 'Application time',
            cs: 'Corresponding sales',
            peuci: 'Please enter your contact information',
            pnfiw: 'Phone number format is wrong',
            psafs: 'Please select a financial system',
            psac: 'Please select a currency',
            pstcs: 'Please select the corresponding sales',
            Poa: 'Purpose of application',
            Oc: 'Other categories',
            ot: 'other types',
            AppClass: 'Application classification',
            Pfitbu: 'Please fill in the business unit',
            Pstapc: 'Please select the application purpose category'
                // : "",
        },
        // 活动信息
        activityInfo: {
            ei: 'Event information',
            noa: 'Event Name',
            bu: 'Business unit',
            coa: 'Event Category',
            foa: 'Event Format',
            Organizer: 'Organizer',
            hdjd: 'Event Base',
            jdlx: 'Base contact information',
            ht: 'Host type',
            pt: 'Participatory type',
            atomc: 'Association/third-party organization/multi-party organization',
            tnoptbi: 'Number of Attendees',
            mta: 'Main target audience',
            toa: 'Event Type',
            cms: 'Channel Meeting Segmentation',
            ps: 'Product support',
            hc: 'Host city',
            edoh: 'Event Starts on',
            eed: 'Event Ends on',
            hdcdtj: 'Event venue inquiry',
            jma: 'Joint marketing activities',
            ic: 'International channels',
            cn: 'Channel Name',
            csl: 'Activity Level',
            cst: 'Channel Signing Type',
            skca: 'Senior/Key Customer Activity',
            skcaP: 'Please select senior/key customer activity',
            hdmb: 'Event Target',
            hdmbP: 'Please fill in the final target tasks that the event needs to achieve.',
            otherTargetObject: 'Other Target Object',
            otherTargetObjectP: 'Please enter other target object',
            otherTargetObjectFormat: 'Other ({content})',
            dynags: 'Do you need active group support?',
            ba: 'Budget Amount',
            ki: 'Critical Actions',
            rpn: 'Remote POC Name',
            nofd: 'Name of fine drill',
            noc: 'Name of Circle',
            tn: 'Template name',
            rp: 'Remote POC',
            jra: 'Event Cooperate with Essence Diamond',
            ca: 'Circle activities',
            mv: 'Site Visit',
            machineDemo: 'Prototype demonstration/experience',
            psteeis: 'Please select the Expected Event Inclusion section',
            IS: 'Industry Solutions',
            Industry: 'Industry',
            ActivityBgA: 'Activity Background & Purpose',
            Bitt: 'Brief introduction to the background/purpose of the event',
            teietcs: 'Event agenda includes',
            artpl: 'Related Product Lines',
            desc: 'Note: The application for online headquarters activities needs to be submitted 15 days in advance, and the application for offline activities needs to be submitted one month in advance. If you did not apply on time, please fill in the reason',
            pscst: 'Please select channel signing type',
            psacn: 'Please select a channel name',
            psabu: 'Please select a business unit',
            pstaacn: 'Please select the associated activity category name',
            tedcblttcd: 'The expected date cannot be less than the current date',
            tsdcbgtted: 'The start date cannot be greater than the end date',
            pepl: 'Please enter product line',
            peteis: 'Please enter the expected inclusion section',
            peba: 'Please enter budget amount',
            petrfa: 'Please enter the reason for application',
            peen: 'Please enter event name',
            psaac: 'Please select an activity category',
            pstmt: 'Please select the main target',
            psao: 'Please select an organizer',
            pehc: 'Please enter host city',
            psaet: 'Please select an event type',
            pshdjd: 'Please select the event base',
            psjdlx: 'Please enter the contact information of the base',
            psacms: 'Please select a channel Meeting segment',
            psaef: 'Please select an event format',
            pettnop: 'Please enter the total number of participants',
            psasd: 'Please select a start date',
            psaed: 'Please select an end date',
            psapl: 'Please select a product line',
            perp: 'Please enter remote POC',
            pejda: 'Please enter joint drilling activity',
            peca: 'Please enter circle activity',
            peastv: 'Please enter a sample to visit',
            psMachineDemo: 'Please enter the prototype demonstration/experience',
            Peacp: 'Please enter a custom product',
            ta: 'Template activity',
            Pstpote: 'Please select the purpose of the event',
            Psac: 'Please select another category',
            Psyip: 'Please select your industry program',
            Aan: 'Associated Activity Name:',
            Tbicfta: 'The basic information contains fields that are not filled in. Please check carefully',
            TypeM: 'Type of meeting',
            NoRL: 'No report link',
            Psttoa: 'Please select the Event Type',
            tas: 'activity kit',
            dmp: 'DM Micro page',
            QR: 'Wechat QR code',
            title: 'The title',
            comsc: 'Communication scenario',
            Pscomsc: 'Please select communication scenario',
            strpr: 'Strategic products',
            Psstrpr: 'Please select strategic products',
            agenda: 'Activity agenda',
            Psagenda: 'Please select activity agenda',
            jkdh: 'Loan order number',
            jkje: 'Amount Borrowed',
            wcxje: 'Unoffset Amount',
            lczt: 'Process Status',
            psps: 'Please select product promotion support',
            sfndghxshd: 'Online activity for the annual plan',
            sfndghxshdTSY: 'Please select Online activity for the annual plan',
            templateActivityName: 'Template Activity Name',
            headquarterActivityName: 'Headquarters Event Name'
        },
        // 拟邀请客户
        Customers: {
            ctbi: 'Customers to be invited',
            psctbi: 'Please select customers to be invited',
            ei: 'Excel Import',
            eu: 'Excel Update',
            dt: 'Download Template',
            ac: 'Add customer',
            ufsce1: 'Uploaded file size cannot exceed 10M',
            ahtci: 'Already have this customer information',
            dnar: 'Do not add repeatedly',
            CustomerName: 'CustomerName',
            ci: 'Customer Identity',
            catt: 'Customer attribute',
            bo: 'Business opportunities',
            // 推动业务机会
            pbo: 'Pushed business opportunities',
            gjjl: 'Follow up records',
            pdty: 'Produced during the year',
            newBusOpp: 'Possible to generate new business opportunitie',
            xqyz: 'Requirements Validation',
            khxq: 'Customer Requirements',
            isyxq: 'Contains Requirements',
            yyz: 'Verified',
            cc: 'Customer Category',
            bc: 'Must Follow Customer',
            ccd: 'Customer Category Details',
            ccon: 'Customer contact',
            ccat: 'Contact Category',
            cst: 'Channel Signing Type',
            noc: 'Name of Circle',
            wtb: 'Whether to build',
            cb: 'Co-built',
            ncc: 'Non-co-construction',
            pecnpci: 'Please enter customer name/province/city/industry',
            tctftrcn: 'Tianyancha, click to find the real customer name',
            bon: 'Business Opportunity Name',
            pecn: 'Please enter customer name',
            psci: 'Please select customer identity',
            pscr: 'Please select customer requirements',
            peabon: 'Please enter a business opportunity name',
            pecc: 'Please enter customer contact',
            psacc: 'Please select a contact category',
            pecst: 'Please enter channel subscription type',
            pswtb: 'Please select whether to build',
            psac: 'Please select a client',
            tincmtsc: 'There is no customer matching the search criteria, you can click the button below to  customize to add customers',
            ca: 'Custom Add',
            nd: 'No data~, please enter the customer name you want to add in the input box above to  search for customers',
            Pecu: 'Please enter customer unit',
            Petcea: 'Please enter the correct email address',
            crmkh: ' CRM customer',
            psfiw: 'Please enter phone number'
            // : "",
        },
        // 活动目录
        Catalogue: {
            t: 'active directory',
            zrs: 'Total number of people to be invited (covered)',
            dws: 'Total number of target units to be invited (covered)',
            create3m: 'Expected number of new business opportunities within 3 months',
            push3m: 'Expected to drive business opportunities within 3 months',
            create3mAmount: 'Expected new business opportunity amount within 3 months (10K)',
            push3mAmount: 'Expected driven business opportunity amount within 3 months (10K)',
            pzrs: 'Please input total number of people to be invited',
            pdws: 'Please input number of target units to be invited',
            pcreate3m: 'Please input expected number of new business opportunities within 3 months',
            ppush3m: 'Please input expected to drive business opportunities within 3 months'
        },
        // 费用归属
        Attribute: {
            rjfyys: 'Per Capita Budget',
            dchdfysx: 'Single Event Cost Ceiling',
            rjfyystsy: 'Please enter per capita budget',
            dchdfysxtsy: 'Please fill in the single event cost ceiling and per capita cost ceiling',
            aoe: 'Budget Ownership',
            None: 'If there is no suitable department or expense type options displayed, you can contact the marketing team for consultation.',
            Ntwo: 'If there is no department or expense type you need to belong to, you can ask the corresponding sales contact area to consult the corresponding product.',
            aca: 'Add cost attribution',
            tc: 'Total Budget',
            hdfyzj: 'Total activity costs',
            hdfybz: 'Notes on the cost of the activity',
            fygsbz: 'Expense attribution notes',
            qxd: 'Place an order',
            ggfyzj: 'Budget for Advertising Materials',
            psca: 'Please select cost attribution',
            pspar: 'Please select the key participation/landing regions',
            tao: 'The amount of xxxxx fee cannot be greater than the reported amount',
            pstcad: 'Please select the cost attribution department',
            psaft: 'Please select a fee type',
            psams: 'Please select a market segment',
            bppsapl: 'Brand Promotion Please select a product line',
            ffna: 'Fees for non-editable activities',
            ndc: 'Non-editable advertising costs',
            srmf: 'SMB Regional Market Fund',
            metc: 'Marketing Expenses - Template Campaign',
            cad: 'Budget Department',
            toe: 'Types of expenses',
            at: 'Activity Application Time',
            bat: 'Report Time Range',
            bb: 'Budget balance',
            ms: 'Market segment',
            pl: 'Product line',
            ac: 'Event Budget',
            coam: 'Budget for Advertising Materials',
            aa: 'Total Budget Applied',
            bbje: 'Amount of activity',
            psbbje: 'Please fill in the reported amount',
            roha: 'Report of headquarters activities',
            DueTT: 'Due to the recent switch of the gift library, the documents that have been rejected or recalled and modified need to be re-selected to place an order. Sorry for the inconvenience caused by the system!',
            dcoa: 'Budget Details',
            tp: 'Total Budget',
            aar: 'Add a row',
            pspc: 'Please select Item',
            ttafcb0: 'The total application fee cannot be 0.',
            pc: 'Item',
            pup: 'Unit Price',
            nop: 'Quantity',
            sp: 'Total Price',
            breakdownAdvertising: 'Breakdown of advertising costs',
            OrderNumber: 'Order number',
            TotalCcosts: 'Total costs',
            Borrowing: '1. Borrowing is not allowed if the current date is later than the estimated end date of the activity.2. Borrowing is not allowed during expense verification.',
            WriteOff: 'Only fee applicants can verify.',
            Revoke: 'This activity contains advertising materials and cannot be cancelled, please verify the cost of advertising materials;The fee is under verification and cannot be revoked;Only the applicant , the product promotion specialist and development manager in the approval process can be revoked;You have unreimbursed Cash Advance and cannot revoke the activity.',
            WriteOffInfo: `When conducting cross-year verification of marketing activity documentation, an email explaining the situation is required. For industry expenses, please send to: Industry General Manager; for regional expenses, please send to: Regional Supervisor. For SBG, please CC: SBG - Jiao Mengying, IT - Liu Shulong; for other departments, please CC: Promotion - Qi Xuepeng, IT - Liu Shulong. Only after the supervisor's email reply [Agree to Verification] can cross-year verification of activity documentation be carried out. `,
            RevokeInfo: 'This fee includes gift orders. Currently, it is not supported to directly cancel them in the activity system. Please contact the Gift Collection customer service representative to handle the order and then return to this system to cancel the fee.',
            WriteOffCheck: 'The compliance process has not been completed. Please upload compliance documents in the compliance document attachment section below and submit them to initiate approval. After the compliance approval is completed, initiate the verification process.'
                // : "",
        },
        // 广告品列表
        ADList: {
            loai: 'List of Advertising Items',
            mc: 'My choice',
            rss: 'Ruijie self-supplied',
            Ep: 'E-commerce products',
            pewtsf: 'Please enter what to search for',
            Category: 'Category:',
            Am: 'And more',
            Stock: 'Stock',
            isEmpty: "It's empty",
            inoia: 'Incorrect number of items added',
            tpisafsita: 'This product is not available for sale in this area',
            pari: 'Please add region information',
            pfitriac: 'Please fill in the receipt information and check the advertisement information  carefully',
            ri: 'Receipt information',
            na: 'New Address',
            da: 'Default address',
            Collapse: 'Collapse',
            Address: 'Address',
            AddMana: 'Address management',
            OE: 'Ordinary Express',
            SfAir: 'Sf Air collect',
            SfE: 'Sf Express highway collect',
            Pictures: 'Pictures',
            noa: 'Name of advertisement',
            up: 'Unit price',
            no: 'Number of',
            sm: 'Shipping Method',
            ss: 'Shipped separately',
            fcpos: 'Follow Customer Purchase Order Shipping',
            Subtotal: 'Subtotal',
            ctc: 'Continue to choose',
            gong: 'A total of ',
            atoxxa: ' advertisements',
            Total: 'Total',
            csbii: 'Current stock balance is insufficient',
            psap: 'Please select a product',
            Cdota: 'Confirm deletion of the address',
            DeleAdd: 'Delete address',
            Dwtstaatda: 'Determines whether to set this address as the default address',
            Sada: 'Set as default address',
            Aa: 'Address area',
            Da: 'Detailed address',
            Mp: 'Mobile phone',
            Peacp: 'Please enter a contact person',
            psaat: 'Please select an address type',
            Peypn: 'Please enter your phone number',
            Psap: 'Please select a province',
            Psaci: 'Please select a city',
            Psaco: 'Please select a county',
            Psas: 'Please select a street/town',
            Pefa: 'Please enter full address',
            Psacou: 'Please select a country',
            Province: 'Province',
            City: 'City',
            DC: 'District County',
            St: 'Street/town',
            At: 'Address type',
            Regional: 'Regional',
            Area: 'Area',
            CreationTime: 'Creation Time',
            InviteSourceName: 'Invitation Source',
            ContactQuality: 'Contact Information Quality',
            CustomerUnit: 'Customer Unit',
            ContactNumber: 'Contact Number',
            Email: 'Email',
            Industry: 'Industry',
            Domestic: 'Domestic',
            International: 'International',
            Country: 'Country',
            Sad: 'Set as default',
            Sales: 'Sales',
            SalerName: 'SalerName',
            xqcp: 'Required Product',
            xpms: 'Requirement Description'
                // : "",
        },
        // 拟邀请客户统计
        inviteCustomer: {
            ca: 'Customer attributes',
            noocc: 'Number of old customer units',
            noucc: 'Number of new customer units',
            nolcc: 'Number of listed customer units',
            noncc: 'Number of non-listed customer units',
            nocfuc: 'Number of new channel units',
            nolccx: 'Number of listed channel units',
            nonlcc: 'Number of units in non-listed channels',
            contactCompletionRate: 'Contact information completeness rate',
            contactExceptionCount: 'Number of abnormal contact information entries',
            tbps: 'Number of target business opportunities promoted',
            contactCompletionRateInfo: 'Contact information completeness rate = Number of complete contact information entries / Total number of contact information entries * 100%\nExplanation of complete contact information: The three pieces of information, namely customer contact, contact phone number, and email, are all complete and error-free.',
            contactExceptionCountInfo: 'The three pieces of information, namely customer contact, contact phone number, and email, have missing/incorrect entries.'
        },
        Ycon: 'You are about to cancel this event, please confirm!'
    },
    // 活动列表
    eventList: {
        AppStatus: 'Approval status',
        AppDepa: 'Application Department',
        Ms: 'Material state',
        BIFind: 'BI Find',
        Configured: 'Configured',
        NotCon: 'Not configured',
        ActCode: 'Activity code',
        Afc: 'Apply for channel',
        Department: 'Department',
        Me: 'Marketing expenses',
        QC: 'Quality Commissioner',
        Doi: 'Degree of importance',
        NotEva: 'Not evaluated',
        Feasibility: 'Feasibility',
        Sos: 'Strength of support',
        Revoke: 'Revoke',
        Rc: 'Recall changes',
        AppPro: 'Approval Process',
        Fad: 'Fee attribution department (click to view approval details)',
        EAAF: 'Event Application Approval Flow',
        AvAf: 'Activity verification Approval flow',
        Taoa: 'Total amount of activity',
        Psaem: 'Please select an event manager',
        Peac: 'Please enter approval comment',
        Yanaafte: 'You are not an applicant for the event and cannot be recalled',
        OKRMta: 'OK Recall Modify this activity?',
        qdzhxam: 'Confirm recall and modification?',
        PsaeiuFA: 'Please select an expense item under Fee Attribution',
        Aysywtctf: 'The budget will be restored after the expense is revoked. Are you sure you want to revoke this expense?',
        bbzsqcxtsy: 'After canceling the activity, the budget will be returned, and the corresponding activity filing documentation will also be canceled. Please confirm whether you wish to continue canceling the activity.',
        qdcxgfym: 'Are you sure you want to revoke this expense?',
        qdcxgfymhd: 'After canceling the activity, the budget will be returned, and the corresponding activity filing documentation will also be canceled. Please confirm whether you wish to continue canceling the activity.',
        FeeAA: 'Fee Total Budget Appliedt',
        Tsosro: 'The system only supports recall operations for a single expense attribution in  the process',
        Position: 'Position',
        PR: 'Purchase Request',
        VPR: 'View Purchase Records',
        Aore: 'Attribution of revoked expenses',
        Acie: 'Advertising cost is empty',
        Iehnyetp: 'This event has not yet entered the participants, do you want to enter now?',
        SPV: 'Service Provider Verification',
        CI: 'Collection Information',
        Print: 'Print',
        Doa: 'Details of activities',
        Tac: 'Total actual costs',
        Au: 'Attachment upload',
        Uei: 'Upload electronic invoice',
        NonI: 'Non-invoice (upload contracts, bills and other attachments)',
        Pctpi: 'Please complete the payment information',
        Peaup: 'Please enter actual unit price',
        Peaq: 'Please enter actual quantity',
        PaymentType: 'Payment Type',
        BanName: 'Bank account name',
        Pwtbil: 'Province/municipality where the bank is located',
        Cwtbil: 'City where the bank is located',
        Aob: 'Account opening branch',
        Psyp: 'Please select your province/municipality',
        Ban: 'Bank account number',
        TIn: 'Tax ID number',
        Aup: 'Actual unit price',
        ActualN: 'Actual number',
        ActualS: 'Actual subtotal',
        Psyb: 'Please select your bank',
        Pstpwtbil: 'Please select the province where the bank is located',
        Pstcwtbil: 'Please select the city where the bank is located',
        BankPayment: 'Bank payment',
        AccountType: 'Account type',
        ExternalUnit: 'External unit',
        AccountBank: 'Account Bank',
        CustomerInfo: 'Customer information',
        Psaec: 'Please select an exported customer',
        Austdtc: 'Are you sure to delete the client?',
        Austdtsc: 'Are you sure you want to delete this customer? After deletion, this customer will not be included in the actual attendance list.',
        Psactc: 'Please select a client to close',
        LoanAmount: 'Loan amount',
        PaymentDate: 'Payment date',
        RepaymentDate: 'Repayment Date',
        ContractNumber: 'Contract number',
        Dotuof: 'Description of the use of funds',
        Tdpiii: 'The document participates in interest-bearing, interest-bearing interest rate (daily interest): ',
        ReceiptInfo: 'Receipt information',
        Mop: 'Method of payment',
        ReceivingUnit: 'Receiving unit',
        Pepnopn: 'Please enter payee name or payee name',
        AccountNumber: 'Account Number',
        BranchName: 'Branch name',
        Pfitla: 'Please fill in the loan amount',
        psapd: 'Please select a payment date',
        Pfitpi: 'Please fill in the payment information',
        Psaat: 'Please select an account type',
        Psapu: 'Please select a payment unit',
        InternalStaff: 'Internal staff',
        ExternalInd: 'External individuals',
        TaufitliPcc: 'There are unfilled fields in the loan information, please check carefully',
        Petoetn: 'Please enter the original event ticket number'
            // : "",
    },
    // 审批中心
    approvalCenter: {
        copoa: 'Classification of Purpose of Application',
        ReportActivity: 'Report of activity',
        ComplianceApplication: 'Compliance Application',
        ActivityApplication: 'Activity Application',
        ActivityNumber: 'Event Number',
        EventName: 'Event Name',
        TypeOfActivity: 'Event Type',
        TheApplicant: 'The Applicant',
        ExpenseDepartment: 'Expense department',
        TypeFee: 'Type of fee',
        AnnualBudget: 'Annual Budget (Yuan)',
        BalanceBudget: 'Balance of budget (Yuan)',
        NumberApprovals: 'You have approved the trip',
        AmountApprovals: 'You have approved the amount',
        _NumberApprovals: 'You are waiting for approval',
        _AmountApprovals: 'You need to approve the amount',
        CorrespondingSales: 'Corresponding sales',
        Department: 'Department',
        TimeApplication: 'Time of Application',
        MarketingExpenses: 'Marketing expenses',
        DegreeImportance: 'Degree of importance',
        AbilityExecute: 'Ability to execute',
        StrengthSupport: 'Strength of support',
        ToDealWith: 'To deal with',
        StatusMaterial: 'Status of material',
        ConsentBulk: 'Consent in bulk',
        AttributionExpenses: 'Budget Ownership',
        MarketSegmentation: 'Market segmentation',
        AmountApplication: 'Amount of application',
        CostActivities: 'Cost of activities',
        CostAdvertisingDoods: 'Cost of advertising goods',
        TotalBudget: 'Total budget',
        ReasonsApplication: 'Reasons for Application',
        MaterialMoving: 'Material for moving',
        FOE: 'Feedback of execution',
        PCU: 'Participating customer Units',
        SyncCRM: 'To CRM',
        SyncCRMSuccess: 'Success!',
        PromptMsg1: 'You have not entered the participating customer units, so you cannot submit the implementation feedback. Do you want to enter it?',
        PromptMsg2: 'Please select at least one early support',
        PromptMsg3: 'Please select at least one post support',
        PromptMsg4: 'The actual number of participants must be greater than 0, please enter the participating customer units',
        PromptMsg5: 'There is no data ~, please enter the customer name you want to add in the input box above for customer search',
        PromptMsg6: 'If you do not find the customer matching the search criteria, you can click the button below to add the new data Oh ~',
        ActualStartDate: 'Actual start date',
        ActualEndDate: 'Actual end date',
        ppss: 'Product push support situation',
        anop: 'Actual number of participants (excluding internal employees)',
        anop1: 'Actual number of participants (excluding internal employees) - Number of HT clients',
        jaon: 'Joint activities or not',
        hydaq: 'Have you done a questionnaire',
        KOL: 'KOL Endorsement/Model Customer Sharing',
        Demo: 'Prototype demonstration/experience',
        iaon: 'Important activity or not',
        sdat: 'Select date and time',
        ass: 'Activity Support Status',
        ess: 'Early stage support',
        oss: 'On-site Support',
        jspc: 'Joint service providers/channels',
        rfncq: 'Reasons for not collecting questionnaires',
        noqc: 'Number of questionnaires collected',
        nosl: 'Number of sales leads',
        oan: 'Original activity number',
        fp: 'Feedback person',
        tof: 'Time of feedback',
        lmt: 'Last modified time',
        pswtja: 'Please select whether to join activities',
        psic: 'Please select international channel',
        pswtdtqon: 'Please select whether to do the questionnaire or not',
        pskol: 'Please select KOL endorsement/ model customer sharing',
        psmd: 'Please select prototype demonstration/experience',
        psaia: 'Please select an important activity',
        pstpps: 'Please select the product push situation',
        toc: 'Type of Customer',
        tyc: 'Sky eye survey',
        ceog: 'Customer entry operation guide',
        PsaeiuFA: 'Please select an expense item under Fee Attribution',
        EventManager: 'Event manager',
        Psaem: 'Please select an event manager',
        Peac: 'Please enter approval comment',
        AppCom: 'Approval comment',
        ActivityCustomerVOCLink: 'Activity customer VOC record link'

    },
    // 按钮
    btn: {
        Close: 'Close',
        Open: 'Open',
        BS: 'Batch shutdown',
        EC: 'Exporting Customers',
        Export: 'Export',
        OverviewExport: 'Overview Export',
        DetailExport: 'Detail Export',
        New: 'New',
        Edit: 'Edit',
        Create: 'Create',
        Delete: 'Delete',
        Submit: 'Submit',
        Cancel: 'Cancel',
        OK: 'OK',
        Return: 'Return',
        Discard: 'Discard',
        Add: 'Add',
        SaveD: 'Save the draft',
        CancelFil: 'Cancel filing',
        TransferApp: 'Transfer application',
        Reset: 'Reset',
        Search: 'Search',
        CollspseS: 'Collapse  Search',
        AdvancedS: 'Advanced  Search',
        Revoke: 'Revoke',
        Borrowing: 'Borrowing',
        WriteOff: 'Reimbursement',
        Doc: 'Details of cancellation',
        RecallC: 'Recall changes',
        zh: 'Recall',
        ActivityE: 'Activity evaluation',
        Agree: 'Agree',
        Rejected: 'Rejected',
        BatchDel: 'Batch deletion',
        BatchAdd: 'Batch add',
        View: 'View',
        Yes: 'Yes',
        No: 'No',
        Modify: 'Modify'
            // : "",
    },
    // 通用
    general: {
        new: 'new',
        ps: 'Please select',
        peak: 'Please enter a keyword',
        psad: 'Please select a date',
        cbe: 'Cannot be empty',
        pec: 'Please enter content',
        yes: 'Yes',
        no: 'No',
        Client: 'Client',
        Ocus: 'Old customers',
        Ncus: 'New customer',
        Channel: 'Channel',
        media: 'Media',
        Rjis: 'Ruijie internal staff',
        msch: 'Marketing system channel',
        mscu: 'Marketing system customer',
        md: 'Marketing database',
        Other: 'Other',
        All: 'All',
        fujian: 'fujian',
        Operation: 'Operation',
        fd: 'Fine drilling',
        cp: 'Contact Person',
        Uploader: 'Uploader',
        Note: 'Note',
        Remarks: 'Remarks',
        Hint: 'Hint',
        NoData: 'No data',
        ctView: 'Click to view',
        AppRules: 'Application Rules',
        SubSucc: 'Submitted successfully',
        SaveSucc: 'Save success',
        AddSucc: 'Add success',
        EditSucc: 'Edit success',
        DeleSucc: 'Deleted successfully',
        SetupSucc: 'Setup successful',
        OperSucc: 'Operation successful',
        ModSucc: 'Modified successfully',
        ImpSucc: 'Import succeeded',
        AppSucc: 'Approval Successful',
        SuccLoan: 'Successful loan',
        EventsEditor: 'Events Editor',
        ReportEditor: 'Report Editor',
        OKSad: 'Please confirm to save it as a draft. Otherwise, the entered event data will be cleared.',
        BasicInfo: 'Basic information',
        End: 'End',
        Status: 'Status',
        Man: 'Man',
        Women: 'Women',
        PsDi: 'Please select Delete item',
        Aystdtd: 'Are you sure to delete this draft?',
        SaveTime: 'Save time',
        Download: 'Download',
        Preview: 'Preview',
        jump: 'Jump',
        Normal: 'Normal',
        Failure: 'Failure',
        undone: 'undone',
        Rejected: 'Rejected',
        ClickEnter: 'Click Enter',
        CEtsbn: 'Click Enter to search by name',
        CE_awysN: 'Click Enter, (appears when you select No)',
        ServerError: 'Server error',
        StartTime: 'Start time',
        EndTime: 'End time',
        ExportSuccess: 'Export successful',
        ExportFailure: 'Export failed',
        Loading: 'Loading...'
            // : "",
    },
    // 文件
    file: {
        Annex: 'Annex',
        aa: 'Attachments',
        xa: 'Attachments',
        Na: 'Attachment name',
        F10M: 'Supports up to 10M files',
        F50M: 'Supports up to 50M files',
        ctu: 'Click to upload',
        Fuf: 'File upload failed',
        Fus: 'File upload successful',
        Fds: 'File deletion successful',
        FPdar: 'File upload failed, please delete and re-upload',
        FPdaua: 'File upload failed, please delete and upload again',
        uFn10M: 'Uploaded file size cannot exceed 10M',
        uFn50M: 'Uploaded file size cannot exceed 50M',
        ImportCustomers: 'Import Customers',
        CustomerInfoIT: 'Customer information import template',
        CustomerInfoIEX: 'Customer information update template',
        SupFF: 'Supported file formats：.xls .xlsx',
        Ctdtt: 'Click to download the template',
        FileU: 'File Upload',
        UploadTime: 'Upload time',
        Limit1: 'The current limit is 3 files, this time ',
        Limit2: ' files are selected, a total of ',
        Limit3: ' files are selected',
        fileName: 'File name',
        DocumentName: 'Document name',
        hdzlfj: 'Compliance documents attachment'
            // : "",
    },
    // 通知说明
    notic: {
        NOTIC: 'NOTIC',
        FXINFO: 'Risk Warning',
        NOTICContent: '2022年营销活动平台关闭通知',
        tcuafc: 'The campaign you applied for contains advertising orders. Due to e-commerce  reasons, the order will expire after 7 days. Please ensure that the campaign order is approved within 7 days.',
        AppRule: 'Description of application rules',
        AppRuleOne: 'Partner application activities need to be applied in the system 15 days in advance for reasonable planning and investment of resources (costs, personnel, content tools, etc.); if you do not apply in advance as required, you will  not be able to obtain support such as personnel and content tools.',
        AppNotic: 'The activity reporting period is from 20th to 30th/31st of each month, and cannot  be reported for the rest of the month. In case of temporary unexpected events, please communicate and agree with the person in charge of expenses, and apply for activities through the activity application channel',
        zhinfo: 'Please confirm whether the above information is accurate. If it is accurate, click the confirm button below to submit the application. If the information is incorrect, click the modify button to modify the information~',
        ActivityNotice: 'Activity submission successful, do you need to jump to the market database to view relevant activity information?',
        addUserErrA: 'Are you sure you want to continue adding customers who have not selected any business opportunities and may generate new business opportunities?',
        addUserErrB: 'The customer you want to add has unselected business opportunities. Are you sure you want to continue adding?',
        addUserErrC: 'Are there any customers that have not been selected and may generate new business opportunities for the customer you want to add? Are you sure you want to continue adding?',
        applicationUpload: 'the target value is 0, and the data serves as an important basis for activity approval. Confirm whether to continue submitting or return for modification',
        costinfo: 'The activity application fee is 0. Do you want to continue submitting? After submission, the reported amount will be released and the budget will be returned. ',
        create3m: 'Create new business',
        push3m: 'Push business',
        and: 'and',
        hgtsinfo: 'Please upload event materials that have undergone compliance self-review and confirmation by the Line of Business, including PPTs, posters, content scripts, etc.',
        witeOffInfo: 'Please confirm whether to initiate write-off'
        // : "",
    },
    // 活动申请配置
    ruleConfig: {
        ruleSort: 'Rule Sort',
        createUser: 'Creator',
        addDialogTitle: 'Add Activity Request Configuration',
        editDialogTitle: 'Edit Activity Request Configuration',
        conditionName: 'Condition Name',
        conditionValue: 'Corresponding value',
        addCondition: 'Add condition',
        addFieldTitle: 'Add Field'
    },
    // 活动质量
    activityQuality: {
        // 核心结果数据
        coreResultData: 'Core Result Data',
        // 实际参会人数(不含内部员工人数)
        actualAttendanceNum: 'Actual Number of Attendees (excluding internal staff)',
        // 实际到会目标单位数(单位数)
        actualTargetUnitNum: 'Actual Number of Target Units Attended (units)',
        // 实际新建业务机会数(个数)
        actualNewBusinessNum: 'Actual Number of New Business Opportunities (count)',
        // 实际推动业务机会数(个数)
        actualPushBusinessNum: 'Actual Number of Business Opportunities Advanced (count)',
        // 愿意进一步交流客户单位数(单位)
        willingToExchangeCustomerUnitNum: 'Number of Customer Units Willing to Further Communicate (units)',
        // 7天跟进单位数
        followUpUnitNum: 'Number of Units Followed Up Within 7 Days',
        // 实际新建业务机会金额(万元)
        actualNewBusinessAmount: 'Actual Amount of New Business Opportunities (10,000 RMB)',
        // 实际推动业务机会金额(万元)
        actualPushBusinessAmount: 'Actual Amount of Business Opportunities Advanced (10,000 RMB)',
        tableColumn: {
            // 实际达成情况
            actualAchievementSituation: 'Actual Achievement Situation',
            // 目标率
            targetRate: 'Target Rate',
            // 实际率
            actualRate: 'Actual Rate',
            // 是否达标
            isAchieved: 'Achieved or Not',
            // 权重
            weight: 'Weight',
            // 实际值
            actualValue: 'Actual Value',
            // 取值周期
            valueCycle: 'Value Cycle',
            // 天
            days: 'Days',
            // 目标值
            targetValue: 'Target Value',
            // 预设目标
            presetTarget: 'Preset Target',
            // 实际达成
            actualAchievement: 'Actual Achievement',
            // 完成率
            completionRate: 'Completion Rate'
        },
        // 及时评估结果数据
        timelyAssessmentResultData: 'Timely Assessment Result Data',
        // 目标客户到会率(单位数)
        targetCustomerAttendanceRate: 'Target Customer Attendance Rate (units)',
        // 参会率(人数)
        attendanceRate: 'Attendance Rate (people)',
        // 愿意进一步交流率(单位数)
        willingToExchangeCustomerRate: 'Willingness to Further Communicate Rate (units)',
        // 个人预设目标完成情况
        personalPresetTargetCompletionSituation: 'Personal Preset Target Completion Situation',
        // 活动质量评估
        singleActivityQualityAssessment: 'Activity Quality Assessment',

        // 目标客户到会率
        targetCustomerAttendanceRate: 'Target Customer Attendance Rate',
        // 参会率
        attendanceRate: 'Attendance Rate',
        // 愿意进一步交流率（单位）
        willingToExchangeCustomerRateUnit: 'Willingness to Further Communicate Rate (units)',

        // 拟邀请人数
        plannedInviteNum: 'Planned Number of Invitees',
        // 实际参会人数
        actualAttendanceNum: 'Actual Number of Attendees',
        // 拟邀请目标单位数
        plannedInviteUnitNum: 'Planned Number of Target Units Invited',
        // 实际到会目标单位数
        actualTargetUnitNum: 'Actual Number of Target Units Attended',
        // 预计3个月内新建业务机会数
        plannedNewBusinessNum: 'Planned Number of New Business Opportunities within 3 Months',
        // 实际新建业务机会数
        actualNewBusinessNum: 'Actual Number of New Business Opportunities',
        // 预计3个月内推动业务机会数
        plannedPushBusinessNum: 'Planned Number of Business Opportunities Advanced within 3 Months',
        // 实际推动业务机会数
        actualPushBusinessNum: 'Actual Number of Business Opportunities Advanced',
        // 愿意进一步交流客户单位数（单位数）
        willingToExchangeCustomerUnitNum: 'Willingness to Further Communicate Customer Units',

        // 实际新建业务机会率（单位）
        actualNewBusinessRateUnit: 'Actual New Business Opportunity Rate (units)',
        // 实际推动业务机会率（单位）
        actualPushBusinessRateUnit: 'Actual Business Opportunity Advancement Rate (units)',
        // 综合完成率
        comprehensiveCompletionRate: 'Comprehensive Completion Rate',

        // 愿意进一步交流客户单位数
        willingToExchangeCustomerUnitNumx: 'Willingness to Further Communicate Customer Units',

        // 参会的客户单位数
        actualAttendanceUnitNum: 'Actual Number of Customer Units Attended',

        // 新建业务机会单位数
        actualNewBusinessUnitNum: 'Actual Number of New Business Opportunity Units',

        // 实际参会单位数
        actualAttendanceUnitNum: 'Actual Number of Customer Units Attended',
        // 推动业务机会的单位数
        actualPushBusinessUnitNum: 'Actual Number of Business Opportunity Units Advanced',
        // 参会CRM客户
        actualAttendanceCrmCustomerNum: 'Actual Number of CRM Customers Attended'
    },
    // 行业报备
    industryReport: {
        hdxxName: 'Activity Information',
        hdxx: {
            hdmc: 'Activity Name',
            yxzt: 'Marketing Theme',
            ywdy: 'Business Unit',
            yxxs: 'Marketing Form',
            hdfl: 'Activity Category',
            hdxs: 'Activity Form',
            zbf: 'Organizer',
            zymbdx: 'Main Target Audience',
            mbfgkhhx: 'Target Customer Profile',
            yqf: 'Inviter',
            gjsc: 'Key Market',
            jbcs: 'Host City',
            mxqgfb: 'Nationwide Release',
            mxhy: 'Target Industry',
            yjjbzq: 'Expected Holding Period',
            hdgjb: 'Activity Toolkit',
            gjjc: 'Key Measures',
            hdsjcpx: 'Involved Product Lines',
            zlcp: 'Strategic Product',
            ybcg: 'Model Visit',
            mbhd: 'Template Activity',
            gjblj: 'Toolkit Link'
        },
        hdxxtsy: {
            hdmc: 'Please enter activity name',
            yxzt: 'Please enter marketing theme',
            ywdy: 'Please enter business unit',
            yxxs: 'Please select marketing form',
            hdfl: 'Please select activity category',
            hdxs: 'Please select activity form',
            zbf: 'Please select organizer',
            zymbdx: 'Please select main target audience',
            mbfgghhx: 'Please enter target customer profile',
            yqf: 'Please select inviter',
            gjsc: 'Please enter key market',
            jbcs: 'Please enter host city',
            mxqgfb: 'Please select nationwide release',
            mxhy: 'Please select target industry',
            yqjbzq: 'Please select expected holding period',
            hdbjmd: 'Please enter activity background & purpose',
            hdgjb: 'Please enter activity toolkit',
            gjjc: 'Please select key measures',
            hdsjcpx: 'Please select involved product lines',
            zlcp: 'Please select strategic product',
            gjblj: 'Please enter toolkit link'
        },
        zdchqy: {
            name: 'Key Participation/Implementation Region',
            qymc: 'Region Name',
            jycc: 'Suggested Sessions',
            hj: 'Total'
        },
        zdchqytsy: {
            qymc: 'Please enter region name',
            jycc: 'Please enter suggested sessions'
        },
        hybblb: {
            cxtj: {
                bbbh: 'Report Number',
                hdmc: 'Activity Name/Marketing Theme',
                yxfs: 'Marketing Form',
                ffzq: 'Nationwide Release',
                sqr: 'Applicant',
                dyxs: 'Corresponding Sales',
                bm: 'Department',
                bbsj: 'Report Time',
                hdgjb: 'Activity Toolkit',
                yxfy: 'Marketing Expense',
                shzt: 'Approval Status',
                bbr: 'Reporting Person',
                hy: 'Industry',
                nyqzrs: 'Invited Total Number',
                zdldqy: 'Key Participation/Implementation Region',
                hybbr: 'Industry Reporting Person',
                qymc: 'Region Name'

            },
            list: {
                bbbh: 'Reporting Code',
                hdmc: 'Activity Name/Marketing Theme',
                yxfs: 'Marketing Form',
                ffzq: 'Released Nationwide',
                sqr: 'Applicant',
                dyxs: 'Corresponding Sales',
                bm: 'Department',
                bbsj: 'Reporting Time',
                hdgjb: 'Activity Toolkit',
                yxfy: 'Marketing Expense',
                shzt: 'Approval Status',
                bbr: 'Reporter',
                hy: 'Industry',
                nyqzrs: 'Planned Total Invitees',
                zdldqy: 'Key Implementation Regions',
                hybbr: 'Industry Reporter',
                qymc: 'Region Name',
                mbkhhx: 'Target Customer Persona',
                dcfysx: 'Single Session Cost Cap',
                fyyq: 'Cost Requirement',
                rjfysx: 'Per Capita Cost Cap',
                sqzje: 'Applied Total Amount',
                zcc: 'Total Sessions',
                qybbzcc: 'Total Regional Reported Sessions',
                bbsptgcc: 'Approved Reported Sessions',
                ysqcc: 'Applied Sessions',
                bbzys: 'Total Reported Budget',
                syysye: 'Remaining Budget Amount',
                bblx: 'Reporting Type',
                syksqje: 'Remaining Available Application Amount'

            },
            tsy: {
                bblx: 'Please select reporting type',
                qxzdcw: 'Please select at least one piece of data'
            }

        }
    },
    customerCalibration: {
      Title: {
        calibrationResult: 'Calibration results of participating units',
        crmSuggestedName: 'CRM Suggested Customer',
        tycSuggestedName: 'Tianyancha Suggested Customer'
      },
      CountList: {
        customerCount: 'Total number of client units',
        crmCustomerCount: 'Number of CRM client units',
        nonCrmCustomerCount: 'Number of non-CRM client units',
        accurateCustomerCount: 'Number of Tianyancha client units',
        inaccurateCustomerCount: 'Number of non-Tianyancha client units',
        downloadDetail: 'Download Details'
      },
      CustomerList: {
        customerName: 'Customer Name (Double-click to change to CRM Customer)',
        isCrmCustomer: 'Is CRM Customer',
        isAccurate: 'Is Tianyancha Customer',
        crmSuggestedName: 'CRM Suggested Name',
        tycSuggestedName: 'Tianyancha Suggested Name',
        clickCalibration: 'Click to calibrate'
      },
      Info: {
        tip: 'The following client units do not match the CRM client names. It is recommended to verify them before importing into the system.',
        warnningStart: 'Among the imported customer units, there is',
        warnningEnd: 'data entry with an inaccurate unit name. Do you still want to continue the import?',
        noData: 'No similar customer names were found. Please click on Customer Name Calibration!'
      }
    },
    exportCompliance: {
      startReview: 'Initiate Review',
      detectError: 'Compliance detection service is abnormal, please try again later',
      detectFailedPass: 'Compliance detection failed. This submission was not compliance-checked.',
      detectFailedPrecheck: 'Compliance detection failed. Unable to verify compliance of this content. Continue to submit?',
      warnDefault: 'This submission did not pass compliance review.',
      noEvidence: 'Missing detection evidence, unable to initiate review',
      interceptNo: 'Review No.',
      reviewCreated: 'Review request created',
      hitSubjects: 'Hit subjects'
    }
};
